import { render, staticRenderFns } from "./sameAccidentsDetail.vue?vue&type=template&id=97f16132"
import script from "./sameAccidentsDetail.vue?vue&type=script&lang=js"
export * from "./sameAccidentsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f16132')) {
      api.createRecord('97f16132', component.options)
    } else {
      api.reload('97f16132', component.options)
    }
    module.hot.accept("./sameAccidentsDetail.vue?vue&type=template&id=97f16132", function () {
      api.rerender('97f16132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/same/sameAccidentsDetail.vue"
export default component.exports